import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter-box" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = {
  key: 0,
  class: "p"
}
const _hoisted_6 = {
  key: 1,
  class: "p"
}
const _hoisted_7 = {
  key: 0,
  class: "item-box"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "日期范围", -1)
const _hoisted_9 = {
  key: 0,
  class: "p"
}
const _hoisted_10 = {
  key: 1,
  class: "p"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_elem_options = _resolveComponent("elem-options")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (conf, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item-box",
        key: idx,
        id: 'filter_item_' + idx
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(conf.title), 1),
        _createElementVNode("div", _hoisted_4, [
          ($data.titles[conf.name])
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($data.titles[conf.name]), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, "所有")),
          _createVNode(_component_elem_icon, {
            class: "icon",
            name: "select"
          })
        ]),
        _createVNode(_component_elem_options, {
          el: '#filter_item_' + idx,
          data: conf.data,
          onSelect: ($event: any) => ($options.onFilter(conf.name, $event.value))
        }, null, 8, ["el", "data", "onSelect"])
      ], 8, _hoisted_2))
    }), 128)),
    ($options.check('1.4.1'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_DatePicker, {
            open: $data.date_open,
            "model-value": $data.dates,
            confirm: "",
            clearable: "",
            type: "daterange",
            "split-panels": "",
            onOnClear: _cache[1] || (_cache[1] = ($event: any) => ($data.date_open = false)),
            onOnClickoutside: _cache[2] || (_cache[2] = ($event: any) => ($data.date_open = false)),
            onOnOk: _cache[3] || (_cache[3] = ($event: any) => ($data.date_open = false)),
            onOnChange: $options.onChangeDate
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "value",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.date_open = true))
              }, [
                ($data.dates)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($data.dates.join(" - ")), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, "所有")),
                _createVNode(_component_elem_icon, {
                  class: "icon",
                  name: "select"
                })
              ])
            ]),
            _: 1
          }, 8, ["open", "model-value", "onOnChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}